module.exports = __webpack_public_path__ + "img/trigger-btn-icon.864a710b.svg";